var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserSignatureCom',{attrs:{"visible":_vm.visible,"title":_vm.title,"getSignatureFn":_vm.getSignatureUrl},on:{"update:visible":_vm.cancel,"signature-success":_vm.signatureSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }